// extracted by mini-css-extract-plugin
export default {"review-body":"_65mm02","reviewBody":"_65mm02"};